// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3E2t_","emails":"CreateEditClinics_emails__16chb","emailTagLabel":"CreateEditClinics_emailTagLabel__3SyOX"};